import { CHANGE_MODAL } from '../../actionsTypes'

export const changeModal = (activeModalId) => ({
  type: CHANGE_MODAL,
  payload: {
    activeModalId: activeModalId,
  },
})
